import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { colorVariantsSelector, currentGiveawayChoiceLimit, isChoiceProductsGiveaway, isOneProductSelector, selectedProductsSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { GiveawayProductColorSelectComponent } from './giveaway-product-color-select';
const currentProductIdSelector = (state, props) => props.productId;
const shouldSkipColorClickSelector = createSelector(selectedProductsSelector, isChoiceProductsGiveaway, currentGiveawayChoiceLimit, currentProductIdSelector, (selectedProducts, isChoice, currentGiveawayLimit, currentProductId) => {
  if (!isChoice || !currentGiveawayLimit) {
    return false;
  }
  if (selectedProducts.size !== currentGiveawayLimit) {
    return false;
  }
  return !selectedProducts.has(currentProductId);
});
const mapStateToProps = createStructuredSelector({
  colors: colorVariantsSelector,
  isOneProduct: isOneProductSelector,
  shouldSkipColorClick: shouldSkipColorClickSelector
});
export const GiveawayProductColorSelect = connect(mapStateToProps)(GiveawayProductColorSelectComponent);